import { render, staticRenderFns } from "./MonthlyEPFSubmissionRecordNew.vue?vue&type=template&id=8058b818"
import script from "./MonthlyEPFSubmissionRecordNew.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFSubmissionRecordNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports